import React, { useState, useEffect } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { GeneralContainer, CategoryContainer } from "./QuestionBankList.styled";
import { ALL_QUESTION_CATEGORIES } from "../../GraphQL/Queries";
import { ReactComponent as OpenModal } from "../../assets/svg/open-modal.svg";
import { useQuery } from "@apollo/client";
import ModalLoader from "../ModalLoader/ModalLoader";

const QuestionBankList = ({ handleOpenQuestionBank }) => {
  const { loading, data } = useQuery(ALL_QUESTION_CATEGORIES);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (data?.allCategoriesQuestion)
      setCategories(data.allCategoriesQuestion.outputData);
  }, [data]);

  return (
    <GeneralContainer>
      {categories.map((record) => {
        return (
          <CategoryContainer>
            <label>{record?.description}</label>
            <Tooltip
              onClick={() =>
                handleOpenQuestionBank({
                  description: record?.description,
                  id: record?.idCategoryQuestion,
                })
              }
              title="Open Question Bank"
            >
              <OpenModal />
            </Tooltip>
          </CategoryContainer>
        );
      })}
      {loading && <ModalLoader></ModalLoader>}
    </GeneralContainer>
  );
};

export default QuestionBankList;
